import { useLocalSearchParams } from 'expo-router';
import { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { ScrollHandlerProcessed } from 'react-native-reanimated';

import { useGetNonProfitOrgs } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrgType } from '@/api/models/nonProfitOrgModels';
import { useAuth } from '@/contexts/authContext';
// import { PreferencesData } from '@/api/models/preferencesModels';
// import { useAuth } from '@/contexts/authContext';
import { useFiltersData } from '@/contexts/filtersContext';

// import useGetLocation from '@/hooks/useGetLocation';
import Dots from '../Dots';
import NpoList from './NpoList';

interface NonProfitOrganizationListProps {
  npoType: NonProfitOrgType;
  onScroll?: ScrollHandlerProcessed<Record<string, unknown>>;
  scrollEnabled?: boolean;
}

// ToDO: Implement location params
const NonProfitOrganizationList = ({ npoType, onScroll, scrollEnabled }: NonProfitOrganizationListProps) => {
  const { state: authState } = useAuth();
  // const type = authState.signUpData?.loginEmail?.type;

  const { state, setFilters } = useFiltersData();
  const { shouldRefresh } = useLocalSearchParams();

  // const location = useGetLocation();

  // ToDO: Define if we are going to preload users preferences or not
  // Set default filters with user data
  // useEffect(() => {
  //   if (state.filtersAppliedCount < 1 && authState.authReady) {
  //     let defaultPreferences: PreferencesData;

  //     // User type
  //     switch (type) {
  //       case 'CHARITIES':
  //         defaultPreferences = {
  //           denominations: [],
  //           religions: [],
  //           programs:
  //             authState.user?.onBoardingPreferenceSecular
  //               ?.at(0)
  //               ?.programTypes.map((item) => item.programTypeId ?? '-') ?? [],
  //           checkbox_selection: undefined
  //         };
  //         break;

  //       case 'CHURCH':
  //         defaultPreferences = {
  //           denominations:
  //             authState.user?.onBoardingPreferenceChurch
  //               ?.at(0)
  //               ?.denominationTypes.map((item) => item.denominationTypeId ?? '-') ?? [],
  //           religions:
  //             authState.user?.onBoardingPreferenceChurch?.at(0)?.religionTypes.map((item) => item.id ?? '-') ?? [],
  //           programs:
  //             authState.user?.onBoardingPreferenceChurch
  //               ?.at(0)
  //               ?.programTypes.map((item) => item.programTypeId ?? '-') ?? [],
  //           checkbox_selection: undefined
  //         };
  //         break;

  //       default:
  //         defaultPreferences = {
  //           denominations:
  //             authState.user?.onBoardingPreference?.denominationTypes.map((item) => item.denominationTypeId ?? '-') ??
  //             [],
  //           religions: authState.user?.onBoardingPreference?.religionTypes.map((item) => item.id ?? '-') ?? [],
  //           programs: authState.user?.onBoardingPreference?.programTypes.map((item) => item.programTypeId ?? '-') ?? [],
  //           checkbox_selection: undefined
  //         };
  //         break;
  //     }

  //     // Remove unncompatible filters for charities
  //     if (npoType === 'CHARITIES') {
  //       defaultPreferences.religions = [];
  //       defaultPreferences.denominations = [];
  //     }

  //     setFilters({
  //       sort_light_rating: 'htl',
  //       denominations: defaultPreferences.denominations,
  //       programs: defaultPreferences.programs,
  //       religions: defaultPreferences.religions,
  //       distance: authState.user?.user?.searchRange ?? 150
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [authState]);

  useEffect(() => {
    if (npoType === 'CHARITIES') {
      setFilters({
        ...state.filtersData,
        denominations: [],
        religions: []
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npoType]);

  const { data, isPending, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage, refetch, isRefetching } =
    useGetNonProfitOrgs({
      radio: state.filtersData.distance,
      type: npoType === 'CHARITIES' ? 'charities' : 'church',
      n: 0,
      limit: 5,
      religions: (state.filtersData.religions as string[]) ?? [],
      denominations: (state.filtersData.denominations as string[]) ?? [],
      programs: (state.filtersData.programs as string[]) ?? [],
      claimed: true,
      sort_light_rating: state.filtersData.sort_light_rating ?? 'htl'
      // longitude: location?.longitude,
      // latitude: location?.latitude,
      // filterByDistance: location ? true : false
    });

  const nposData = data?.pages.flatMap((page) => page.results);

  const userAdministratedNpoId =
    authState.user?.user.role === 'NON_PROFIT_ORG' ? authState.signUpData?.loginEmail?.npoId : undefined;

  const onEndReached = () => {
    hasNextPage && !isFetching && fetchNextPage();
  };

  useEffect(() => {
    if (shouldRefresh) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRefresh]);

  if (isPending)
    return (
      <View style={style.container}>
        <Dots />
      </View>
    );

  return (
    <NpoList
      onScroll={onScroll}
      scrollEnabled={scrollEnabled}
      nposData={nposData}
      onEndReached={onEndReached}
      refetch={refetch}
      isRefetching={isRefetching}
      npoType={npoType}
      isFetchingNextPage={isFetchingNextPage}
      userAdministratedNpoId={userAdministratedNpoId}
    />
  );
};

export default NonProfitOrganizationList;

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
});
